// 产品图片
import productPng1 from '../assets/images/product/product1.png'
import product1_1 from '../assets/images/product/product1_1.png'
import product1_1_1 from '../assets/images/product/product1_1_1.png'
import product1_1_2 from '../assets/images/product/product1_1_2.png'
import product1_1_3 from '../assets/images/product/product1_1_3.png'
import product1_1_4 from '../assets/images/product/product1_1_4.png'
import product1_2_1 from '../assets/images/product/product1_2_1.png'
import product1_2_2 from '../assets/images/product/product1_2_2.png'
import product1_2_3 from '../assets/images/product/product1_2_3.png'
import product1_2_4 from '../assets/images/product/product1_2_4.png'
import product1_2_5 from '../assets/images/product/product1_2_5.png'
import product1_2_6 from '../assets/images/product/product1_2_6.png'

import productPng2 from '../assets/images/product/product2.png'
import product2_1 from '../assets/images/product/product2_1.png'
import product2_1_1 from '../assets/images/product/product2_1_1.png'
import product2_1_2 from '../assets/images/product/product2_1_2.png'
import product2_1_3 from '../assets/images/product/product2_1_3.png'
import product2_1_4 from '../assets/images/product/product2_1_4.png'
import product2_2_1 from '../assets/images/product/product2_2_1.png'
import product2_2_2 from '../assets/images/product/product2_2_2.png'
import product2_2_3 from '../assets/images/product/product2_2_3.png'

import productPng3 from '../assets/images/product/product3.png'
import product3_1 from '../assets/images/product/product3_1.png'
import product3_1_1 from '../assets/images/product/product3_1_1.png'
import product3_1_2 from '../assets/images/product/product3_1_2.png'
import product3_1_3 from '../assets/images/product/product3_1_3.png'
import product3_2_1 from '../assets/images/product/product3_2_1.png'
import product3_2_2 from '../assets/images/product/product3_2_2.png'
import product3_2_3 from '../assets/images/product/product3_2_3.png'
import product3_2_4 from '../assets/images/product/product3_2_4.png'
import product3_2_5 from '../assets/images/product/product3_2_5.png'
import product3_2_6 from '../assets/images/product/product3_2_6.png'

import productPng4 from '../assets/images/product/product4.png'
import product4_1 from '../assets/images/product/product4_1.png'
import product4_1_1 from '../assets/images/product/product4_1_1.png'
import product4_2_1 from '../assets/images/product/product4_2_1.png'
import product4_2_2 from '../assets/images/product/product4_2_2.png'
import product4_2_3 from '../assets/images/product/product4_2_3.png'
import product4_3_1 from '../assets/images/product/product4_3_1.png'

import productPng5 from '../assets/images/product/product5.png'
import product5_1 from '../assets/images/product/product5_1.png'
import product5_1_1 from '../assets/images/product/product5_1_1.png'
import product5_2_1 from '../assets/images/product/product5_2_1.png'
import product5_3_1 from '../assets/images/product/product5_3_1.png'
import product5_4_1 from '../assets/images/product/product5_4_1.png'
import product5_1_1_1 from '../assets/images/product/product5_1_1_1.png'

import productPng6 from '../assets/images/product/product6.png'
import product6_1 from '../assets/images/product/product6_1.png'
import product6_1_1 from '../assets/images/product/product6_1_1.png'
import product6_2_1 from '../assets/images/product/product6_2_1.png'
import product6_3_1 from '../assets/images/product/product6_3_1.png'
import product6_4_1 from '../assets/images/product/product6_4_1.png'
import product6_1_1_1 from '../assets/images/product/product6_1_1_1.png'
import product6_1_1_2 from '../assets/images/product/product6_1_1_2.png'
import product6_1_1_3 from '../assets/images/product/product6_1_1_3.png'
import product6_1_1_4 from '../assets/images/product/product6_1_1_4.png'
import product6_1_1_5 from '../assets/images/product/product6_1_1_5.png'
import product6_1_1_6 from '../assets/images/product/product6_1_1_6.png'

import productPng7 from '../assets/images/product/product7.png'
import product7_1 from '../assets/images/product/product7_1.png'
import product7_1_1 from '../assets/images/product/product7_1_1.png'
import product7_2_1 from '../assets/images/product/product7_2_1.png'
import product7_3_1 from '../assets/images/product/product7_3_1.png'
import product7_1_1_1 from '../assets/images/product/product7_1_1_1.png'
import product7_1_1_2 from '../assets/images/product/product7_1_1_2.png'
import product7_1_1_3 from '../assets/images/product/product7_1_1_3.png'
import product7_1_1_4 from '../assets/images/product/product7_1_1_4.png'
import product7_1_1_5 from '../assets/images/product/product7_1_1_5.png'
import product7_1_1_6 from '../assets/images/product/product7_1_1_6.png'


import productPng8 from '../assets/images/product/product8.png'
import product8_1 from '../assets/images/product/product8_1.png'
import product8_1_1 from '../assets/images/product/product8_1_1.png'
import product8_2_1 from '../assets/images/product/product8_2_1.png'
import product8_3_1 from '../assets/images/product/product8_3_1.png'
import product8_4_1 from '../assets/images/product/product8_4_1.png'

//首页图片
import homePng1 from '../assets/images/home/home1.png'
import homePng2 from '../assets/images/home/home2.png'
import homePng3 from '../assets/images/home/home3.png'
import homePng4 from '../assets/images/home/home4.png'
import homePng5 from '../assets/images/home/home5.png'
//案例图片
import casePng1 from '../assets/images/case/case1.PNG'
import casePng2 from '../assets/images/case/case2.PNG'
import casePng3 from '../assets/images/case/case3.PNG'
import casePng4 from '../assets/images/case/case4.png'
import casePng5 from '../assets/images/case/case5.PNG'
import casePng6 from '../assets/images/case/case6.PNG'
import casePng7 from '../assets/images/case/case7.PNG'
import casePng8 from '../assets/images/case/case8.PNG'


import casePng56 from '../assets/images/case4/天津舞台租赁.png'
import casePng57 from '../assets/images/case4/英国户外项目案例.png'
import casePng58 from '../assets/images/case4/南通户外租赁项目.png'

import casePng10 from '../assets/images/case1/上海室内小间距.jpg'
import casePng11 from '../assets/images/case1/会议室室内项目.png'
import casePng12 from '../assets/images/case1/会议室小间距.png'
import casePng13 from '../assets/images/case1/会议室案例.png'
import casePng15 from '../assets/images/case1/会议室项目.jpg'
import casePng16 from '../assets/images/case1/医院会议室项目.jpg'
import casePng18 from '../assets/images/case1/博物馆小间距室内屏.png'
import casePng19 from '../assets/images/case1/商场室内项目.png'
import casePng20 from '../assets/images/case1/商场小间距.png'
import casePng21 from '../assets/images/case1/商场户外大屏.png'
import casePng22 from '../assets/images/case1/商场服装店.png'


import casePng30 from '../assets/images/case3/LED晶膜屏.png'
import casePng31 from '../assets/images/case3/会议展示魔方屏.png'
import casePng32 from '../assets/images/case3/服装店LED魔方屏.png'
import casePng33 from '../assets/images/case3/超市.png'
import casePng34 from '../assets/images/case3/超市室内LED魔方屏.png'
import casePng35 from '../assets/images/case3/餐饮店LED魔方屏.png'
import casePng36 from '../assets/images/case3/魔方办公室摆台.png'
import casePng37 from '../assets/images/case3/餐饮案例.png'
import casePng38 from '../assets/images/case3/餐馆案例.PNG'
import casePng39 from '../assets/images/case3/晶膜屏案例.PNG'

import casePng40 from '../assets/images/case2/上海商场项目.png'
import casePng41 from '../assets/images/case2/上海铁塔项目.png'
import casePng42 from '../assets/images/case2/上海闵行项目.png'
import casePng43 from '../assets/images/case2/保定博物馆项目.png'
import casePng44 from '../assets/images/case2/北京珠宝店项目.png'
import casePng45 from '../assets/images/case2/商场透明屏案例.png'
import casePng46 from '../assets/images/case2/商演项目.png'
import casePng47 from '../assets/images/case2/圆形透明屏案例.png'
import casePng48 from '../assets/images/case2/地铁站项目.png'
import casePng49 from '../assets/images/case2/宁波户外项目.png'

import { getLangName as t } from './index'

export const caseList4 = [{
  title: t('ShanghaiShoppingMallProject'),
  img: casePng40,
}, {
  title: t('ShanghaiTowerProject'),
  img: casePng41,
}, {
  title: t('ShanghaiMinhangProject'),
  img: casePng42,
}, {
  title: t('BaodingMuseumProject'),
  img: casePng43,
}, {
  title: t('BeijingJewelryStoreProject'),
  img: casePng44,
}, {
  title: t('ShoppingMallTransparentScreenCase'),
  img: casePng45,
}, {
  title: t('CommercialPerformanceProject'),
  img: casePng46,
}, {
  title: t('RoundTransparentScreenCase'),
  img: casePng47,
}, {
  title: t('SubwayStationProject'),
  img: casePng48,
}, {
  title: t('NingboOutdoorProject'),
  img: casePng49,
}]

export const caseList3 = [{
  title: t('LEDCrystalFilmScreen'),
  img: casePng30,
}, {
  title: t('ConferenceDisplayMagicCubeScreen'),
  img: casePng31,
}, {
  title: t('ClothingStoreLEDMagicCubeScreen'),
  img: casePng32,
}, {
  title: t('Supermarket'),
  img: casePng33,
}, {
  title: t('SupermarketIndoorLEDMagicCubeScreen'),
  img: casePng34,
}, {
  title: t('RestaurantLEDMagicCubeScreen'),
  img: casePng35,
}, {
  title: t('MagicCubeOfficeDisplay'),
  img: casePng36,
}, {
  title: t('RestaurantCase'),
  img: casePng37,
}, {
  title: t('DiningCase'),
  img: casePng38,
}, {
  title: t('CrystalFilmScreenCase'),
  img: casePng39,
}]

export const caseList2 = [{
  title: t('ShanghaiIndoorSmallPitch'),
  img: casePng10,
}, {
  title: t('MeetingRoomIndoorProject'),
  img: casePng11,
}, {
  title: t('MeetingRoomSmallPitch'),
  img: casePng12,
}, {
  title: t('MeetingRoomCase'),
  img: casePng13,
}, {
  title: t('MeetingRoomProject'),
  img: casePng15,
}, {
  title: t('HospitalMeetingRoomProject'),
  img: casePng16,
}, {
  title: t('MuseumSmallPitchIndoorScreen'),
  img: casePng18,
}, {
  title: t('MuseumSmallPitchIndoorScreen'),
  img: casePng18,
}, {
  title: t('ShoppingMallIndoorProject'),
  img: casePng19,
}, {
  title: t('ShoppingMallSmallPitch'),
  img: casePng20,
}, {
  title: t('ShoppingMallOutdoorLargeScreen'),
  img: casePng21,
}, {
  title: t('ShoppingMallClothingStore'),
  img: casePng22,
}]

export const caseList5 = [{
  title: t('TianjinStageRental'),
  img: casePng56,
}, {
  title: t('UKOutdoorProjectCase'),
  img: casePng57,
}, {
  title: t('NantongOutdoorRentalProject'),
  img: casePng58,
}]

export const caseList1 = [{
  title: t('P186FiveUnitsParallel'),
  img: casePng1,
}, {
  title: t('P25Indoor'),
  img: casePng2,
}, {
  title: t('CakeShopCase'),
  img: casePng3
}, {
  title: t('ClothingStoreCase'),
  img: casePng4
}, {
  title: t('DigitalSignageCase'),
  img: casePng5
}, {
  title: t('IndoorDigitalSignage2'),
  img: casePng6
}, {
  title: t('IndoorDigitalSignage3'),
  img: casePng7
}, {
  title: t('IndoorDigitalSignage'),
  img: casePng8
}]

export const homeList = [{
  title: t('home1'),
  img: homePng1,
}, {
  title: t('home2'),
  img: homePng2,
}, {
  title: t('home3'),
  img: homePng3,
}, {
  title: t('home4'),
  img: homePng4,
}, {
  title: t('home5'),
  img: homePng5,
}]
const productList = [{
  key: '1',
  title: t('product1'),
  img: productPng1,
  detailImg: product1_1,
  detail: [{
    title: t("product1_1"),
    content: [t('prcducrt1_1_1'), t('prcducrt1_1_2'), t('prcducrt1_1_3')],
    img: product1_1_1
  }, {
    title: t('product1_2'),
    content: [t('prcduct1_2_1'), t('prcduct1_2_2'), t('prcduct1_2_3')],
    img: product1_1_2
  }, {
    title: t('product1_3'),
    content: [t('product1_3_1'), t('product1_3_2')],
    img: product1_1_3
  }, {
    title: t('product1_4'),
    content: [t('product1_4_1'), t('product1_4_2')],
    img: product1_1_4
  }],
  detailBox: {
    label: t('product1_1_1_1'),
    imgs: [{
      title: t('product1_1_1_2'),
      img: product1_2_1,
    }, {
      title: t('product1_1_1_3'),
      img: product1_2_2,
    }, {
      title: t('product1_1_1_4'),
      img: product1_2_3,
    }, {
      title: t('product1_1_1_5'),
      img: product1_2_4,
    }, {
      title: t('product1_1_1_6'),
      img: product1_2_5,
    }, {
      title: t('product1_1_1_7'),
      img: product1_2_6,
    }]
  }
}, {
  key: '2',
  title: t('product2'),
  img: productPng2,
  detailImg: product2_1,
  detail: [{
    title: t('product2_1'),
    content: [t('product2_1_1'),
    t('product2_1_2'),
    t('product2_1_3')],
    img: product2_1_1
  }, {
    title: t('product2_2'),
    content: [t('product2_2_1'),
    t('product2_2_2')],
    img: product2_1_2
  }, {
    title: t('product2_3'),
    content: [t('product2_3_1'),
    t('product2_3_2'),],
    img: product2_1_3
  }, {
    title: t('product2_4'),
    content: [t('product2_4_1'),
    t('product2_4_2')],
    img: product2_1_4
  }],
  detailBox: {
    label: t('product2_1_1_1'),
    imgs: [{
      title: t('product2_1_1_2'),
      img: product2_2_1
    }, {
      title: t('product2_1_1_3'),
      img: product2_2_2
    }, {
      title: t('product2_1_1_4'),
      img: product2_2_3
    }]
  }
}, {
  key: '3',
  title: t('product3_1'),
  img: productPng3,
  detailImg: product3_1,
  detail: [{
    title: t('product3_1_1'),
    content: [t('product3_1_2'),
    t('product3_1_3'),
    ],
    img: product3_1_1
  }, {
    title: t('product3_2_1'),
    content: [t('product3_2_2')],
    img: product3_1_2
  }, {
    title: t('product3_3_1'),
    content: [t('product3_3_2'),
    t('product3_3_3'),
    t('product3_3_4'),
    ],
    img: product3_1_3
  }],
  detailBox: {
    label: t('product3_1_1_1'),
    imgs: [{
      title: t('product3_1_1_2'),
      img: product3_2_1
    }, {
      title: t('product3_1_1_3'),
      img: product3_2_2
    }, {
      title: t('product3_1_1_4'),
      img: product3_2_3
    }, {
      title: t('product3_1_1_5'),
      img: product3_2_4
    }, {
      title: t('product3_1_1_6'),
      img: product3_2_5
    }, {
      title: t('product3_1_1_7'),
      img: product3_2_6
    }]
  }
}, {
  key: '4',
  title: t('product4_1'),
  img: productPng4,
  detailImg: product4_1,
  detail: [{
    title: t('product4_1_1'),
    content: [t('product4_1_2'), t('product4_1_3')],
    img: product4_1_1
  }, {
    title: t('product4_2_1'),
    content: [t('product4_2_2'),],
    img: product4_2_1
  }, {
    title: t('product4_3_1'),
    content: [t('product4_3_2')],
    img: product4_2_2
  }, {
    title: t('product4_4_1'),
    content: [t('product4_4_2'), t('product4_4_3'), t('product4_4_4'),],
    img: product4_2_3
  }],
  detailBox: {
    label: t('product4_1_1_1'),
    imgs: [{
      title: '',
      img: product4_3_1
    }]
  }
}, {
  key: '5',
  title: t('product5_1'),
  img: productPng5,
  detailImg: product5_1,
  detail: [{
    title: t('product5_1_1'),
    content: [t('product5_1_2')],
    img: product5_1_1
  }, {
    title: t('product5_2_1'),
    content: [t('product5_2_2')],
    img: product5_2_1
  }, {
    title: t('product5_3_1'),
    content: [t('product5_3_2')],
    img: product5_3_1
  }, {
    title: t('product5_4_1'),
    content: [t('product5_4_2')],
    img: product5_4_1
  },],
  detailBox: {
    label: t('product5_1_1_1'),
    imgs: [{
      title: '',
      img: product5_1_1_1
    }]
  }
}, {
  key: '6',
  title: t('product6_1'),
  img: productPng6,
  detailImg: product6_1,
  detail: [{
    title: t('product6_1_1'),
    content: [t('product6_1_2')],
    img: product6_1_1
  }, {
    title: t('product6_2_1'),
    content: [t('product6_2_2')],
    img: product6_2_1
  }, {
    title: t('product6_3_1'),
    content: [t('product6_3_2')],
    img: product6_3_1
  }, {
    title: t('product6_4_1'),
    content: [t('product6_4_2')],
    img: product6_4_1
  }],
  detailBox: {
    label: t('product6_1_1_1'),
    imgs: [{
      title: t('product6_1_1_2'),
      img: product6_1_1_1
    }, {
      title: t('product6_1_1_3'),
      img: product6_1_1_2
    }, {
      title: t('product6_1_1_4'),
      img: product6_1_1_3
    }, {
      title: t('product6_1_1_5'),
      img: product6_1_1_4
    }, {
      title: t('product6_1_1_6'),
      img: product6_1_1_5
    }, {
      title: t('product6_1_1_7'),
      img: product6_1_1_6
    }]
  }
}, {
  key: '7',
  title: t('product7_1'),
  img: productPng7,
  detailImg: product7_1,
  detail: [{
    title: t('product7_1_1'),
    content: [t('product7_1_2')],
    img: product7_1_1
  }, {
    title: t('product7_2_1'),
    content: [],
    img: product7_2_1
  }, {
    title: t('product7_3_1'),
    content: [],
    img: product7_3_1
  }],
  detailBox: {
    label: t('product7_1_1_1'),
    imgs: [{
      title: t('product7_1_1_2'),
      img: product7_1_1_1
    }, {
      title: t('product7_1_1_3'),
      img: product7_1_1_2
    }, {
      title: t('product7_1_1_4'),
      img: product7_1_1_3
    }, {
      title: t('product7_1_1_5'),
      img: product7_1_1_4
    }, {
      title: t('product7_1_1_6'),
      img: product7_1_1_5
    }, {
      title: t('product7_1_1_7'),
      img: product7_1_1_6
    }]
  }
}, {
  key: '8',
  title: t('product8_1'),
  img: productPng8,
  detailImg: product8_1,
  detail: [{
    title: t('product8_1_1'),
    content: [t('product8_1_2')],
    img: product8_1_1
  }, {
    title: t('product8_2_1'),
    content: [t('product8_2_2')],
    img: product8_2_1
  }, {
    title: t('product8_3_1'),
    content: [t('product8_3_2')],
    img: product8_3_1
  }, {
    title: t('product8_4_1'),
    //content: [''],
    img: product8_4_1
  }]
}]

export default productList